import { updateMatrixPosterScale } from "../puzzles/poster";
import { addMarginIfiOSAddressBar } from "./iOSHacks";
import { mobileOrNot } from "./mobileDetect";
import { setVhProperty } from "./storeRealViewportHeight";

const addRemoveMobileClassBody = () => {
  if (mobileOrNot()) {
    document.body.classList.add("mobile");
  } else {
    if (document.body.classList.contains("mobile")) {
      document.body.classList.remove("mobile");
    }
  }
};

export const updateDimensions = (engine) => {
  if (engine) {
    setVhProperty();
    console.log("engine resize");
    engine.resize();
  }
};

export const resizeJobs = engine => {
  if(!engine) engine = BABYLON.EngineStore.LastCreatedEngine;
  addMarginIfiOSAddressBar(engine);
  addRemoveMobileClassBody();
  updateDimensions(engine);
  updateMatrixPosterScale();
}

